import React from "react";
import { AppContext }from "../app/AppContext";

const Home = <div>Home</div>

export const Welcome = (props) => {
    return (   
            <AppContext
                handleLogin = {props.handleLogin}
                handleLogout = {props.handleLogout}
                accessToken = {props.accessToken}
                isAuthenticated = {props.isAuthenticated}
            />
        );  
}
// 

/**
 * 
 * @param {
    *isAuthenticated 
    * handleLogin
    * handleLogout
    * accessToken
    * 
    * } props 
    */
   // const  WelcomeContent = (props) => {
   //   // If authenticated, greet the user
   //   if (props.isAuthenticated) {
   //     return (<AppContext
   //       handleLogout = {props.handleLogout}
   //       accessToken = {props.accessToken}
   //       isAuthenticated = {props.isAuthenticated}
   //       />)
   //   }
   //    // Not authenticated, present a sign in button
   //    // <Home handleLogin = {props.handleLogin} />
   //    return (
   //     <button onClick={props.handleLogin}>
   //           Login
   //         </button>
   //    );
   // } 
   
   